import type { ChangeEventHandler } from "react";
import useTranslator from "../../hooks/useTranslator";
import { TextField } from "../design";

interface InputFieldProps {
  name: string;
  value: string;
  label: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  isHalf?: boolean;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onBeforeInput?: (event: React.FormEvent<HTMLInputElement>) => void;
}

const InputField = ({
  name,
  value,
  label,
  onChange,
  onKeyDown,
  onBeforeInput,
}: InputFieldProps) => {
  const { _t } = useTranslator();
  return (
    <TextField
      id={`auth-${name}`}
      name={name}
      label={_t(label)}
      placeholder={_t(`enter${label}`, "Text used in onboarding process")}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onBeforeInput={onBeforeInput}
      required
    />
  );
};

export default InputField;
